import { render } from "./EditConfigRatings.vue?vue&type=template&id=50f0ed73"
import script from "./EditConfigRatings.vue?vue&type=script&lang=js"
export * from "./EditConfigRatings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__